"use client";

import { FaqList } from "@/sanity/sanity.types";
import Accordion from "../accordion/accordion";
import css from "./faq.module.scss";
import { PortableText } from "next-sanity";
import BaseLink from "../base-link/base-link";
import InternalLink from "../internal-link";
import { sanitizeLinkSpans } from "@/utilities/sanitizeLinkSpans";

interface IFAQProps {
  data: FaqList;
}

const FAQ = (props: IFAQProps) => {
  const { data } = props;
  const { heading, subheading, items } = data;

  return (
    <div className={css.faq}>
      <h2
        id="faq"
        className={`${css.faqTitle} ${subheading ? "!mb-[16] text-[36px] leading-[48px] lg:!text-center" : ""} text-[24px] text-[#373A36]`}
      >
        {heading}
      </h2>
      <p className="leadng-[22px] mb-[48px] text-[18px] font-medium text-[#4A4A4A] lg:text-center lg:leading-[16px]">
        {subheading}
      </p>
      <div className={css.faqAccordion}>
        {items?.map((item: any, index) => (
          <Accordion expanded key={index} title={item.q}>
            <PortableText
              onMissingComponent={() => null}
              value={sanitizeLinkSpans(item.a)}
              components={{
                types: {
                  undefined: () => null,
                },
                marks: {
                  unknownMark: () => null,
                  internalLink: ({ children, value }: any) => (
                    <InternalLink value={value}>{children}</InternalLink>
                  ),
                  link: ({ children, value }) => (
                    <BaseLink
                      href={value?.href}
                      target={value?.blank ? "_blank" : undefined}
                      rel={value?.blank ? "noopener noreferrer" : undefined}
                      className="text-[#00698F] underline"
                    >
                      {children}
                    </BaseLink>
                  ),
                  strong: ({ children }) => (
                    <strong className="font-semibold">{children}</strong>
                  ),
                  em: ({ children }) => <em className="italic">{children}</em>,
                },
                block: {
                  normal: ({ children }) => (
                    <p className="mb-2 leading-relaxed">{children}</p>
                  ),
                },
                list: {
                  bullet: ({ children }) => (
                    <ul className="mb-3 list-inside list-disc">{children}</ul>
                  ),
                  number: ({ children }) => (
                    <ol className="mb-3 list-inside list-decimal">
                      {children}
                    </ol>
                  ),
                },
                listItem: {
                  bullet: ({ children }) => (
                    <li className="ml-4">{children}</li>
                  ),
                  number: ({ children }) => (
                    <li className="ml-4">{children}</li>
                  ),
                },
              }}
            />
          </Accordion>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
